import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Capabilities from './components/Capabilities';
import Projects from './components/Projects';
import Philosophy from './components/Philosophy';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navigation from './components/Navigation';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative">
      <Navigation isScrolled={isScrolled} />
      <Hero />
      <About />
      <Capabilities />
      <Projects />
      <Philosophy />
      <Contact />
      <Footer />
    </div>
  );
}